import Vue from 'vue';
import axios from 'axios';

const state = Vue.observable({
  lastNotifications: [],
  lastNotificationsCount: 0,
});

const loadLastNotifications = async () => {
  try {
    const response = await axios.get('/notifications/last');
    state.lastNotifications = response?.data?.data ?? [];
    state.lastNotificationsCount = response?.data?.notifications_count ?? 0;
  } catch (err) {
    // console.error('Failed to fetch notifications:', err);
  }
};

export default {
  state,
  loadLastNotifications,
};
